module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.total > 0 && ((_vm.file.archived > 0 && _vm.showArchived) || (_vm.file.unarchived >= 0 && !_vm.showArchived))) ? _c('div', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "file job",
    on: {
      "click": function($event) {
        return _vm.toggleJobs()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1em",
      "height": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-name-block"
  }, [_c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.file.name))])]), _vm._v(" "), _c('div', {
    staticClass: "toggleIcon"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.isOpen, 'fa-chevron-down': !_vm.isOpen
    }
  })])]), _vm._v(" "), (_vm.isOpen) ? [_vm._l((_vm.file.jobs), function(job, jI) {
    return (!(job.parentPathKey || (job.isNested || job.nestedJobName))) ? [(!_vm.showArchived && job.outputsLoaded && Array.isArray(job.jobOutputs) && job.jobOutputs.length === 0) ? _c('div', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_c('div', {
      staticClass: "job jobout"
    }, [_c('div', {
      staticStyle: {
        "flex": "3"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("Unfinished job")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), _c('div', [(_vm.subscription || _vm.user.credits.length > 0) ? [_c('button', {
      staticClass: "a3d btn small inv",
      staticStyle: {
        "margin-left": "0.5em"
      },
      on: {
        "click": function($event) {
          return _vm.createJob(job.id, job.jobPathKey)
        }
      }
    }, [_vm._v("Create\n                            ")])] : _c('button', {
      staticClass: "a3d btn small",
      staticStyle: {
        "margin-right": "0.5em"
      },
      on: {
        "click": _vm.buymodal
      }
    }, [_vm._v("Buy Subscription")]), _vm._v(" "), _c('button', {
      staticClass: "a3d btn small inv",
      staticStyle: {
        "margin-right": "0.5em"
      },
      on: {
        "click": function($event) {
          return _vm.removeJobConfirmation($event, _vm.file.pathKey, job.jobPathKey)
        }
      }
    }, [_vm._v("Remove\n                        ")])], 2)])]) : _vm._e(), _vm._v(" "), _vm._l((job.jobOutputs), function(jobOutput, joI) {
      return (jobOutput.isArchived === _vm.showArchived && job.hasOwnProperty('jobOutputs')) ? _c('div', {
        key: jobOutput.pathKey,
        staticStyle: {
          "margin-left": "30px"
        }
      }, [(jobOutput.paidfor || _vm.subscription || jobOutput.status === 'ERROR') ? [_c('div', {
        staticClass: "job jobout",
        on: {
          "click": function($event) {
            return _vm.toggleJobsFiles(jI, joI)
          }
        }
      }, [(_vm.compareMode && _vm.isCost(jobOutput.outputFiles)) ? _c('input', {
        staticClass: "filled-in",
        attrs: {
          "type": "checkbox",
          "id": jobOutput.jobOutputPathKey
        },
        domProps: {
          "checked": _vm.filesCompare[jobOutput.jobOutputPathKey]
        },
        on: {
          "change": function($event) {
            return _vm.toggleJobCompare({
              jobOutput: jobOutput,
              job: job
            })
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('label', {
        attrs: {
          "for": jobOutput.jobOutputPathKey
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "flex": "3"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v("\n                                " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, false)) + "\n                            ")]), _vm._v(" "), (job.jobDescription) ? _c('div', {
        staticClass: "description"
      }, [_vm._v(_vm._s(job.jobDescription))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length >= 0) ? _c('div', {
        staticClass: "jobout-buttons"
      }, [_c('div', {
        staticClass: "jobout-buttons-row"
      }, [(jobOutput.outputFiles && jobOutput.outputFiles.length > 0) ? [_c('router-link', {
        staticClass: "a3d btn inv small",
        attrs: {
          "to": {
            name: 'ThreeJSViewer',
            params: {
              id: jobOutput.id,
              type: 'output'
            }
          }
        }
      }, [_vm._v("\n                                        View\n                                    ")])] : _vm._e(), _vm._v(" "), (jobOutput.isArchived) ? _c('button', {
        staticClass: "a3d btn small inv",
        attrs: {
          "disabled": _vm.unarchivingProcess[jobOutput.jobOutputPathKey]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.unarchiveJob({
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v(_vm._s(_vm.unarchivingProcess[jobOutput.jobOutputPathKey] ? 'Unarchiving...' : 'Unarchive'))]) : _vm._e(), _vm._v(" "), (!jobOutput.isArchived) ? _c('button', {
        staticClass: "a3d btn small inv",
        attrs: {
          "disabled": _vm.archivingProcess[jobOutput.jobOutputPathKey]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.archiveJob({
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v(_vm._s(_vm.archivingProcess[jobOutput.jobOutputPathKey] ? 'Archiving...' : 'Archive'))]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.resubmitJobConfirmation($event, {
              sourceFilePathKey: _vm.file.pathKey,
              filename: _vm.file.name,
              jobPathKey: job.jobPathKey,
              jobConfig: job.config,
              jobDescription: job.jobDescription,
              jobAnalysisId: jobOutput.analysisId,
              jobObjectiveId: jobOutput.objectiveId
            })
          }
        }
      }, [_vm._v("Re-Submit")])], 2), _vm._v(" "), (_vm.isHasOutput(jobOutput.outputFiles)) ? _c('div', {
        staticClass: "jobout-buttons-row"
      }, [_c('router-link', {
        staticClass: "a3d btn inv small",
        attrs: {
          "to": {
            name: 'ThreeJSViewer',
            params: {
              id: jobOutput.id,
              type: 'output'
            },
            query: {
              modifySupports: true
            }
          }
        }
      }, [_vm._v("Modify Supports")]), _vm._v(" "), (_vm.isHasLog(jobOutput.outputFiles)) ? _c('button', {
        staticClass: "right a3d btn small",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.fileDownload($event, {
              filename: _vm.isHasLog(jobOutput.outputFiles),
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey,
              newTab: true
            })
          }
        }
      }, [_vm._v("Download optimization log")]) : _vm._e(), _vm._v(" "), (_vm.isHasConfigJson(jobOutput.outputFiles)) ? _c('button', {
        staticClass: "right a3d btn small",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.fileDownload($event, {
              filename: _vm.isHasConfigJson(jobOutput.outputFiles),
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey,
              newTab: true
            })
          }
        }
      }, [_vm._v("Download config")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (jobOutput.paidfor || _vm.subscription || jobOutput.status === 'ERROR') ? _c('div', {
        staticClass: "toggleIcon"
      }, [_c('i', {
        staticClass: "fa",
        class: {
          'fa-chevron-up': _vm.jobsFilesToggle[jI][joI], 'fa-chevron-down': !_vm.jobsFilesToggle[jI][joI]
        }
      })]) : _vm._e()])] : [_c('div', {
        staticClass: "job jobout"
      }, [_c('div', [_c('div', [_c('i', [_vm._v(_vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId)))]), _vm._v("\n                                is not yet unlocked.\n                            ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "flex-grow": "1",
          "flex-basis": "50%",
          "align-self": "center"
        }
      }, [(_vm.user.credits.length > 0) ? _c('button', {
        staticClass: "right a3d btn small inv",
        staticStyle: {
          "margin-right": "0.5em"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.unlockJob($event, jobOutput, job)
          }
        }
      }, [_vm._v("Unlock"), _c('br'), _vm._v("(1 credit)\n                            ")]) : _c('a', {
        staticClass: "a3d btn small right",
        on: {
          "click": _vm.buymodal
        }
      }, [_vm._v("Buy Subscription")])])])], _vm._v(" "), (_vm.jobsFilesToggle[jI][joI] && (jobOutput.paidfor || _vm.subscription || jobOutput.status === 'ERROR')) ? [(jobOutput.outputFiles && jobOutput.outputFiles.length > 0) ? _c('div', [_vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
        return (!outputFile.name.match(/\.json$/)) ? _c('div', {
          key: outputFile.name,
          staticStyle: {
            "margin-left": "40px"
          }
        }, [(outputFile.name.match(/^1_.*_0m\.stl$/) &&
          (!outputFile.name.match(/_compensated_0m\.stl$/) &&
            !outputFile.name.match(/_compensated_Renishaw_0m\.stl$/) &&
            !outputFile.name.match(/_compensated_strengthen_0m\.stl$/))) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [(outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Support Structure Renishaw\n                                ")]) : (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Support Structure Polymer\n                                ")]) : (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Strengthening support\n                                ")]) : (!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Support Structure\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesSupportVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesSupport(jI, joI)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesSupport(jI, joI)
            }
          }
        }, [_vm._v("\n                                            Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) &&
            !outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/_compensated_(Renishaw|strengthen)_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesSupport(jI, joI)
              }
            }
          }, [_vm._v("\n                                                            Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                        ")])]) : _vm._e()
        }), 0)])])]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                        Download STL\n                                    ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                        Download STL\n                                    ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                        Download STL\n                                    ")]) : _vm._e()], 1)]) : (outputFile.name.match(/(.*)_output\.stl$/) || outputFile.name.match(/(.*)_new\.stl$/)) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [_c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Oriented Part\n                                ")]), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              return _vm.showEstimateCost($event, {
                filename: 'cost.json',
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesPartVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesPart(jI, joI, false)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesPart(jI, joI)
            }
          }
        }, [_vm._v("\n                                            Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/^(.*)_output\.(?!(txt)$)([^.]{3}$)/) || outputFileNested.name.match(/^.*_new\.[\S]{3}$/)) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesPart(jI, joI)
              }
            }
          }, [_vm._v("\n                                                            Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                        ")])]) : _vm._e()
        }), 0)])])])], 1)]) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), (_vm.getTempList(jI, joI).length) ? _c('div', {
        staticStyle: {
          "margin-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.toggleTemperatureFiles(jI, joI)
          }
        }
      }, [_c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                              Temperature\n                            ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            _vm.allFilesDownload($event, {
              list: _vm.getTempList(jI, joI),
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                                  Download all\n                              ")])]), _vm._v(" "), _c('div', {
        staticClass: "toggleIcon"
      }, [_c('i', {
        staticClass: "fa",
        class: {
          'fa-chevron-up': _vm.temperatureFilesToggle[jI, joI], 'fa-chevron-down': !_vm.temperatureFilesToggle[jI][joI]
        }
      })])]), _vm._v(" "), (_vm.temperatureFilesToggle[jI][joI]) ? [_c('div', {
        staticStyle: {
          "margin-left": "40px"
        }
      }, _vm._l((_vm.getTempList(jI, joI)), function(tempFile, i) {
        return _c('div', {
          key: 'tempDec' + i,
          staticClass: "job jobout jobfile"
        }, [_c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                  " + _vm._s(tempFile.name) + "\n                                ")]), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: tempFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                      Download\n                                  ")])])])
      }), 0)] : _vm._e()], 2) : _vm._e()], 2) : _c('div', [_c('div', {
        staticStyle: {
          "margin-left": "40px"
        }
      }, [_c('div', {
        staticClass: "job jobout job-status"
      }, [_c('div', {
        staticClass: "job-status-message"
      }, [_vm._v("\n                                    " + _vm._s(_vm.displayMessage(jobOutput.status)) + "\n                                    "), (jobOutput.status === 'PROCESSING') ? _c('span', [_vm._v(_vm._s(jobOutput.progress) + "%")]) : _vm._e()]), _vm._v(" "), (jobOutput.status === 'PROCESSING') ? _c('div', {
        staticClass: "progress"
      }, [_c('div', {
        staticClass: "determinate",
        style: ({
          width: jobOutput.progress + '%'
        })
      })]) : _vm._e()])])])] : _vm._e(), _vm._v(" "), (_vm.isHasCompensated(jobOutput.outputFiles) && (jobOutput.paidfor || _vm.subscription)) ? _c('div', {
        staticClass: "job jobout",
        on: {
          "click": function($event) {
            return _vm.toggleJobsFilesCompensated(jI, joI)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex": "3"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v("\n                            " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, true)) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), _c('div', {
        staticClass: "jobout-buttons"
      }, [_c('div', {
        staticClass: "jobout-buttons-row"
      }, [_c('router-link', {
        staticClass: "a3d btn inv small",
        attrs: {
          "to": {
            name: 'ThreeJSViewer',
            params: {
              id: jobOutput.id,
              type: 'output'
            },
            query: {
              compensated: true
            }
          }
        }
      }, [_vm._v("\n                                View\n                            ")])], 1)]), _vm._v(" "), _c('div', {
        staticClass: "toggleIcon"
      }, [_c('i', {
        staticClass: "fa",
        class: {
          'fa-chevron-up': _vm.jobsFilesCompensatedToggle[jI][joI], 'fa-chevron-down': !_vm.jobsFilesCompensatedToggle[jI][joI]
        }
      })])]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && _vm.jobsFilesCompensatedToggle[jI][joI] && (jobOutput.paidfor || _vm.subscription)) ? _vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
        return (!outputFile.name.match(/\.json$/)) ? _c('div', {
          key: outputFile.name + "_compensated",
          staticStyle: {
            "margin-left": "40px"
          }
        }, [(outputFile.name.match(/_compensated_0m\.stl$/) || outputFile.name.match(/_compensated_Renishaw_0m\.stl$/) || outputFile.name.match(/_compensated_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [(outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Support Structure Renishaw\n                            ")]) : (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Support Structure Polymer \n                            ")]) : (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Strengthening support\n                            ")]) : (!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Support Structure\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(!outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesSupportCompensatedVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesSupportCompensated(jI, joI)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesSupportCompensated(jI, joI)
            }
          }
        }, [_vm._v("\n                                        Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) &&
            !outputFileNested.name.match(/^1_magicSupp_0m\.stl$/) &&
            !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/) &&
            (outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/) ||
              outputFileNested.name.match(/_compensated_Renishaw_0m\.[\S]{3}$/))) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesSupportCompensated(jI, joI)
              }
            }
          }, [_vm._v("\n                                                        Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                    ")])]) : _vm._e()
        }), 0)])])]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                    Download STL\n                                ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                    Download STL\n                                ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                    Download STL\n                                ")]) : _vm._e()], 1)]) : (outputFile.name.match(/output_compensated\.stl$/)) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [_c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Oriented Part\n                            ")]), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
          staticClass: "a3d btn inv small nowrap",
          on: {
            "click": function($event) {
              return _vm.showEstimateCost($event, {
                filename: 'cost.json',
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesPartCompensatedVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesPartCompensated(jI, joI)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesPartCompensated(jI, joI)
            }
          }
        }, [_vm._v("\n                                        Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/output_compensated\.[\S]{3}$/)) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesPartCompensated(jI, joI)
              }
            }
          }, [_vm._v("\n                                                        Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                    ")])]) : _vm._e()
        }), 0)])])])], 1)]) : _vm._e()]) : _vm._e()
      }) : _vm._e()], 2) : _vm._e()
    })] : _vm._e()
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (_vm.isCanLoadMore && !_vm.isLoading) ? _c('div', {
    staticClass: "load-more"
  }, [_c('div', {
    staticClass: "job jobout align-center"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.loadMore(_vm.loaded)
      }
    }
  }, [_vm._v("Load more")])])]) : _vm._e()] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49a3b049", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49a3b049"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files/FileOutput.vue
// module id = 484
// module chunks = 1